import { render } from "./index.vue?vue&type=template&id=65afae4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=65afae4c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-65afae4c"

export default script